import React, { useState } from 'react';
import { buttonVariants } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { CopyIcon, Share2Icon, CheckIcon } from "lucide-react";
import { cn } from '@/lib/utils';

const ShareButton = ({ secretShopper }) => {
    const [copied, setCopied] = useState(false);

    const urlToShare = `${process.env.REACT_APP_BASE_URL}/public/secret-shoppers/${secretShopper.hashed_id}`

    const handleCopy = (e) => {
        e.stopPropagation(); // optional: avoids affecting parent click handlers like CollapsibleTrigger
        navigator.clipboard.writeText(urlToShare).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const handleTriggerClick = (e) => {
        e.stopPropagation(); // optional: avoids affecting parent click handlers like CollapsibleTrigger
    };

    return (
        <Popover>
            <PopoverTrigger asChild>
                <div className={cn(buttonVariants({ variant: 'outline', size: 'sm' }))} size="sm" onClick={handleTriggerClick}>
                        <Share2Icon className="w-4 h-4 mr-2" />
                        Share
                </div>
            </PopoverTrigger>
            <PopoverContent className="w-80">
                <div className="flex flex-col gap-2">
                    <span className="text-sm font-medium text-gray-700">Share this link:</span>
                    <div className="flex items-center gap-2">
                        <Input value={urlToShare} readOnly className="flex-1" />
                        <div className={cn(buttonVariants({ variant: 'secondary', size: 'sm' }), 'cursor-pointer')} onClick={handleCopy}>
                            {copied ? <CheckIcon className="w-4 h-4" /> : <CopyIcon className="w-4 h-4" />}
                        </div>
                    </div>
                    {copied && <span className="text-green-600 text-sm">Copied!</span>}
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default ShareButton;
